/**
 * Lifetime of a pre-signed file URL, in seconds.
 *
 * Shared by the two halves that have to agree: the upload paths that ask the
 * backend for a short-lived URL, and the display paths that re-sign before
 * rendering. Splitting this into two literals is how one half ends up at five
 * minutes while the other still assumes ten years.
 */
export const FILE_SECURITY_EXPIRE_IN = 300;

export const PLAN_ID = {
  FREE: 0,
  STARTER: 1,
  EARLIER: 2,
};
export const CLICK_ACTION_ERROR = {
  ELEMENT_VALUE_IS_INVALID: 'ELEMENT_VALUE_IS_INVALID',
  REQUIRED_VALUE: 'REQUIRED_VALUE',
};

export const ELEMENT_ERROR_TEXT = {
  [CLICK_ACTION_ERROR.REQUIRED_VALUE]: 'elementError.required',
};
